// extracted by mini-css-extract-plugin
export var burger = "BurgerButton-module--burger--HB4DP";
export var active = "BurgerButton-module--active--YBFjh";